import React from "react";
import FormGeneric from "../../../../shared/components/generic/form/form-generic";
import DashboardSection from "../../components/section/dashboard-section";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import { equipmentFormConfig } from "../../config/header/equipment-form-config";
import "./dashboard-header.css";

const DashboardHeader = ({
    equipmentOptions = [],
    selectedEquipment = "",
    onEquipmentChange,
    purchaseSummary = {},
    totalGrantedDiscounts = 0
}) => {
    const {
        totalValue = 0,
        purchaseDate = "-",
        downPaymentValue = 0,
        installmentsQuantity = "-",
        installments = []
    } = purchaseSummary;

    return (
        <DashboardSection columns="header" className="dashboard-header">
            <div className="dashboard-header__equipment">
                <FormGeneric
                    formId="dashboard-equipment-form"
                    formFields={equipmentFormConfig({
                        equipmentOptions,
                        selectedEquipment
                    })}
                    onSubmit={() => { }}
                    onFieldChange={({ name, value }) => {
                        if (name === "equipment" && typeof onEquipmentChange === "function") {
                            onEquipmentChange(value);
                        }
                    }}
                />
            </div>

            <div className="dashboard-header__simulation">
                <dl className="dashboard-header__details">
                    <div className="dashboard-header__detail">
                        <dt>Valor:</dt>
                        <dd>{MonetaryUtils.formatCurrency(totalValue)}</dd>
                    </div>

                    <div className="dashboard-header__detail">
                        <dt>Data da compra:</dt>
                        <dd>{purchaseDate}</dd>
                    </div>

                    <div className="dashboard-header__detail">
                        <dt>Entrada:</dt>
                        <dd>{MonetaryUtils.formatCurrency(downPaymentValue)}</dd>
                    </div>

                    <div className="dashboard-header__detail">
                        <dt>Parcelas:</dt>
                        <dd>{installmentsQuantity}</dd>
                    </div>
                </dl>

                <dl className="dashboard-header__installments">
                    {installments.map(installment => (
                        <div
                            key={installment.label}
                            className="dashboard-header__detail"
                        >
                            <dt>{installment.label}:</dt>
                            <dd>{installment.value}</dd>
                        </div>
                    ))}
                </dl>
            </div>

            <aside className="dashboard-header__discount-card">
                <span>Total de descontos já concedidos:</span>
                <strong>{MonetaryUtils.formatCurrency(totalGrantedDiscounts)}</strong>
            </aside>
        </DashboardSection>
    );
};

export default DashboardHeader;